
export default class Player {
    uuid:string
    

    avatarUri:string|null
    //countryCode:
    rating:number|null
    /** @deprecate isDemo */
    isDemo:boolean 
    is_robot:boolean
    
    name:string
    description:string
    type_id:number // TODo enum
    
    active_account_uuid:string
    created_timestamp:number
    created:string

    constructor(data:any) {
        Object.assign(this, data);
    }
    
}



// avatarUri: "https://wbgdev.ngmcasino.com/nard_server/statics/pictures/avatars/avatar_15.png"
// countryCode: null
// rating: 1469
// isDemo: false
// uuid: "686cb095-1d67-4c25-aae3-5ec99e772d93"
// name: "testPlayer"
// description: "testPlayer"
// type_id: 1
// active_account_uuid: "97c8a2a0-aef5-4fb0-ac62-caeee2e6abac"
// created_timestamp: 1586426420
// created: "2020-04-09 13:00:20+03"
// data: null